import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import { required } from "vuelidate/lib/validators";

export class EuthanasiaEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.actNumber = null;
        this.actDate = null;
        this.postMortemActDate = null;
        this.utilizationDate = null;
        this.executorRepresentative = null;
        this.executorPosition = null;
        this.specialRepresentative = null;
        this.indications = null;
        this.indicationReasons = null;
        this.sedationMeds = null;
        this.sedationMedsQuantity = null;
        this.lethalMeds = null;
        this.lethalMedsQuantity = null;
        this.postMortem = null;
        this.postMortemActNumber = null;
        this.euthanasiaReason = null;
        this.euthanasiaReasonText = null;
        this.euthanasiaReasons = [];
        this.supportingDocumentDate = null;
        this.supportingDocumentNumber = null;
        this.wasteDisposalOrganizationName = null;

        if (initObjectParams && initObjectParams['actDate']) {
            this.actDate = initObjectParams['actDate']
        }

        if (initObjectParams && initObjectParams['utilizationDate']) {
            this.utilizationDate = initObjectParams['utilizationDate']
        }

        if (initObjectParams && initObjectParams['postMortemActDate']) {
            this.postMortemActDate = initObjectParams['postMortemActDate']
        }

        if (initObjectParams && initObjectParams['executorRepresentative']) {
            this.executorRepresentative = initObjectParams['executorRepresentative']
        }

        if (initObjectParams && initObjectParams['executorPosition']) {
            this.executorPosition = initObjectParams['executorPosition']
        }

        if (initObjectParams && initObjectParams['euthanasiaReasons']) {
            this.euthanasiaReasons = initObjectParams['euthanasiaReasons'];
        }

        if (initObjectParams && initObjectParams['supportingDocumentDate']) {
            this.supportingDocumentDate = initObjectParams['supportingDocumentDate']
        }

    }

    static get modelName() {
        return 'DisposalEvent'
    }

    static get validations() {
        return {
            actNumber: {},
            actDate: {},
            utilizationDate: {},
            executorRepresentative: {},
            executorPosition: {},
            specialRepresentative: {},
            indications: {},
            indicationReasons: {},
            sedationMeds: {},
            sedationMedsQuantity: {},
            lethalMeds: {},
            lethalMedsQuantity: {},
            postMortem: {},
            postMortemActNumber: {},
            postMortemActDate: {},
            euthanasiaReason: { required },
            supportingDocumentDate: {},
            supportingDocumentNumber: {},
            wasteDisposalOrganizationName: {}
        }
    }

    static get validationFieldLabels() {
        return {
            actNumber: 'Акт',
            actDate: 'Дата составления',
            utilizationDate: 'Дата утилизации',
            executorRepresentative: 'Представитель исполнителя',
            executorPosition: 'Должность и наименование места работы специалиста в области ветеринарии, проводившего эвтаназию',
            specialRepresentative: 'Представитель специализированной организации',
            indications: 'Показания к проведению',
            indicationReasons: 'Результаты исследований, подтверждающие показания к проведению',
            sedationMeds: 'Препарат для премедикации',
            sedationMedsQuantity: '',
            lethalMeds: 'Препарат для эвтаназии',
            lethalMedsQuantity: '',
            postMortem: 'Результаты посмертной диагностики',
            postMortemActNumber: 'Акт посмертной диагностики',
            postMortemActDate: 'Дата акта посмертной диагностики',
            euthanasiaReason: 'Основание для эвтаназии',
            supportingDocumentDate: 'Дата ветеринарного сопроводительного документа',
            supportingDocumentNumber: 'Номер ветеринарного сопроводительного документа',
            wasteDisposalOrganizationName: 'Наименование организации, осуществляющей уничтожение биологических отходов'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.actNumber = data['actNumber'];
        this.actDate = data['actDate'];
        this.postMortemActDate = data['postMortemActDate'];
        this.utilizationDate = data['utilizationDate'];
        this.executorRepresentative = data['executorRepresentative'];
        this.executorPosition = data['executorPosition'];
        this.specialRepresentative = data['specialRepresentative'];
        this.indications = data['indications'];
        this.indicationReasons = data['indicationReasons'];
        this.sedationMeds = data['sedationMeds'];
        this.sedationMedsQuantity = data['sedationMedsQuantity'];
        this.lethalMeds = data['lethalMeds'];
        this.lethalMedsQuantity = data['lethalMedsQuantity'];
        this.postMortem = data['postMortem'];
        this.postMortemActNumber = data['postMortemActNumber'];
        this.euthanasiaReason = data['euthanasiaReason'];
        this.supportingDocumentDate = data['supportingDocumentDate'];
        this.supportingDocumentNumber = data['supportingDocumentNumber'];
        this.wasteDisposalOrganizationName = data['wasteDisposalOrganizationName'];

        for (const euthanasiaReason of this.euthanasiaReasons) {
            if (euthanasiaReason['id'] === this.euthanasiaReason) {
                this.euthanasiaReasonText = euthanasiaReason['name']
            }
        }

    }

}